import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

const useGetOcrRecordCountApi = (companyId: string, uploadsOlderThan90Days?: boolean) => {
  const call = useCallback(
    () =>
      new Promise<number>((resolve, reject) => {
        axiosInstance
          .get(api.getOcrCount(companyId, uploadsOlderThan90Days))
          .then((data) => {
            resolve(data.data);
          })
          .catch((error) => {
            reject(error);
          });
      }),
    [companyId, uploadsOlderThan90Days]
  );

  const { execute, value } = useAsync(call, false);

  return {
    getOcrRecordCount: execute,
    ocrRecordCount: value,
  };
};

export default useGetOcrRecordCountApi;
